
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/reels/[slug]/[id]",
      function () {
        return require("private-next-pages/(ocelot)/reels/[slug]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/reels/[slug]/[id]"])
      });
    }
  